var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.83 12 4.77-4.77a1.25 1.25 0 0 0 0-1.77L18.54 4.4a1.25 1.25 0 0 0-1.77 0L12 9.17 7.23 4.4a1.25 1.25 0 0 0-1.77 0L4.4 5.46a1.25 1.25 0 0 0 0 1.77L9.17 12 4.4 16.77a1.25 1.25 0 0 0 0 1.77l1.06 1.06a1.25 1.25 0 0 0 1.77 0L12 14.83l4.77 4.77a1.25 1.25 0 0 0 1.77 0l1.06-1.06a1.25 1.25 0 0 0 0-1.77Z"
})));
export default SvgClose;